import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGeneric from "../../../../layout/navigation/buttons/generic";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Tools from "../../../../layout/menu/sections/tools/tools";
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position";


export class SpaceTools extends SpaceProto {



    constructor() {
        super(NavigationSectionType.TOOLS)

        this.title      = "Tools"
        this.svgIcon    = "isvg-tools"
    }

    get navigationStructureConfig() {

        // carefull we must have only 2 options !!!
        // const position = _.get(gd.user.settings.navigation.buttonPositions, this.id) === NavigationButtonPosition.TOP ? NavigationButtonPosition.TOP : NavigationButtonPosition.MORE
        const position = NavigationButtonPosition.STATIC

        return {
            id              : this.id,
            name            : "Tools",
            icon            : "i5-nav-tools",
            iconActive      : "i5-nav-tools-solid",
            hint            : "Tools",
            type            : NavigationSectionType.TOOLS,
            renderComponent : Navigation_ButtonGeneric,
            menuComponent   : MainMenu_Tools,
            onClick         : navigationStructureOnClick,
            // position        : NavigationButtonPosition.STATIC, //getNavigationPosition(NavigationSectionType.TOOLS),
            position        : position,
        }

    }



}